export default {
  items: [
    {
      name: 'Work Space',
      url: '/corporate/spacetags/workspace',
      icon: 'icon-grid',
    },
    {
      name: 'Notification',
      url: '/corporate/spacetags/notification',
      icon: 'icon-speech',
    },
  ]
};
